module.exports = {
  context: {
    name: 'Default',
    layout: 'grid',
    class: 'grid',
    sectionHeading: 'Sample Section Heading',
    pages: [
      {
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/catalyst-community-services.jpg?mtime=20210607142855&focal=none',
          alt: 'Two people talking'
        },
        heading: 'Catalyst Community Services',
        shortDescription: 'We help people within the full spectrum of types of disabilities. Our staff is committed to people with disabilities to help them succeed in their daily lives, work, home and in their communities',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
      {
        image: {
          src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/veterans-community-services.jpg?mtime=20210607143032&focal=none',
          alt: 'woman smiling'
        },
        heading: 'Veterans Community Services',
        shortDescription: 'San Diego County is home to over 235,000 veterans. While many resources exist, Veterans Community Services provides needed help to these wounded heroes.',
        button: {
          text: 'Learn More',
          url: 'https://google.com',
          class: 'cta'
        }
      },
    ]
  },
  variants: [
    {
      name: 'staggered',
      context: {
        layout: 'staggered',
        class: 'staggered',
        sectionHeading: null,
        pages: [
          {
            image: {
              src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/catalyst-community-services.jpg?mtime=20210607142855&focal=none',
              alt: 'Two people talking'
            },
            heading: 'Catalyst Community Services',
            shortDescription: 'We help people within the full spectrum of types of disabilities. Our staff is committed to people with disabilities to help them succeed in their daily lives, work, home and in their communities',
            button: {
              text: 'Learn More',
              url: 'https://google.com',
              class: 'cta'
            }
          },
          {
            image: {
              src: 'https://d2qzg5sxlz4vb2.cloudfront.net/media/veterans-community-services.jpg?mtime=20210607143032&focal=none',
              alt: 'woman smiling'
            },
            heading: 'Veterans Community Services',
            shortDescription: 'San Diego County is home to over 235,000 veterans. While many resources exist, Veterans Community Services provides needed help to these wounded heroes.',
            button: {
              text: 'Learn More',
              url: 'https://google.com',
              class: 'cta'
            }
          },
        ]
      }
    }
  ]
}
